import React from 'react'
import {
  PixelCurrency,
  PixelFlexBox,
  PixelHeaderPanel,
  PixelTable,
  PixelText,
} from 'pixel-base'
import { DarazPaymentTransaction, OrderDetail } from '../../../../../decl'

const columns = [
  {
    dataKey: 'total_paid_by_buyer',
    name: <PixelText>Paid by Buyer</PixelText>,
    sortable: true,
    selector: (row) => row.total_paid_by_buyer,
  },
  {
    dataKey: 'shipping_fee_charged',
    name: <PixelText>Deductions</PixelText>,
    sortable: true,
    selector: (row) => {
      const deduction =
        Number(row.shipping_fee_charged) +
        Number(row.payment_fee_charged_from_seller) +
        Number(row.commission_fee_charged_from_seller) +
        Number(row.shipping_paid_by_buyer)
      return <PixelCurrency hideSymbol value={deduction} />
    },
  },
  {
    dataKey: 'net_payout',
    name: <PixelText>Net Payout</PixelText>,
    sortable: true,
    selector: (row) => row.net_payout,
  },
]
interface IProps {
  details: OrderDetail
}
const DarazPayments = (props: IProps) => {
  const { details = [] } = props
  const ExpandedComponent = ({ data }: { data: DarazPaymentTransaction }) => {
    return (
      <PixelFlexBox
        flexDirection="column"
        style={{
          padding: '10px 10px',
          border: '1px solid #e0e0e0',
        }}
      >
        <PixelText style={{ padding: '5px' }}>
          More Information
          <PixelText variant="light">({data.statement_name})</PixelText>
        </PixelText>
        <PixelFlexBox
          flexDirection="column"
          style={{
            paddingLeft: '10px',
          }}
        >
          {data?.commission_fee_charged_from_seller != '0.00' && (
            <PixelText>
              Commission Fee :&nbsp;
              <strong>
                {data?.commission_fee_charged_from_seller || '0.00'}
              </strong>
            </PixelText>
          )}
          {data?.commission_fee_refunded != '0.00' && (
            <PixelText>
              Commission Fee Refunded:&nbsp;
              <strong>{data?.commission_fee_refunded || '0.00'}</strong>
            </PixelText>
          )}
          {data?.shipping_paid_by_buyer != '0.00' && (
            <PixelText>
              Shipping Fee Paid by Buyer :&nbsp;
              <strong>{data?.shipping_paid_by_buyer || '0.00'}</strong>
            </PixelText>
          )}
          {data?.total_paid_by_buyer != '0.00' && (
            <PixelText>
              Product Price Paid by Buyer:&nbsp;
              <strong>{data?.total_paid_by_buyer || '0.00'}</strong>
            </PixelText>
          )}
          {data?.payment_fee_charged_from_seller != '0.00' && (
            <PixelText>
              Payment Fee: &nbsp;
              <strong>{data?.payment_fee_charged_from_seller || '0.00'}</strong>
            </PixelText>
          )}
          {data?.payment_fee_refunded != '0.00' && (
            <PixelText>
              Payment Fee Refunded: &nbsp;
              <strong>{data?.payment_fee_refunded}</strong>
            </PixelText>
          )}
          {data?.shipping_fee_charged != '0.00' && (
            <PixelText>
              Shipping Fee Subsidy by Daraz:&nbsp;
              <strong>{data?.shipping_fee_charged || '0.00'}</strong>
            </PixelText>
          )}
          {data?.shipping_discount_for_buyer_by_daraz != '0.00' && (
            <PixelText>
              Shipping Discount For Buyer by Daraz:&nbsp;
              <strong>{data?.shipping_discount_for_buyer_by_daraz}</strong>
            </PixelText>
          )}
        </PixelFlexBox>
      </PixelFlexBox>
    )
  }
  return (
    <PixelFlexBox flexDirection="column" height="auto">
      <PixelFlexBox
        flexDirection="column"
        justifyContent="flex-start"
        alignContent="center"
        style={{ borderBottom: '1px solid #e6e6e6' }}
        padding="10px 0px"
        height="auto"
      >
        <PixelHeaderPanel>
          <PixelText>Daraz Transaction Information</PixelText>
        </PixelHeaderPanel>
      </PixelFlexBox>
      <PixelFlexBox>
        <PixelTable
          columns={columns}
          data={details?.daraz_payment_transactions || []}
          pagination={false}
          expandableRows
          expandableRowsHideExpander={false}
          expandableRowsComponent={ExpandedComponent}
          expandOnRowClicked
          highlightOnHover
        />
      </PixelFlexBox>
    </PixelFlexBox>
  )
}

export default DarazPayments
